export interface UserAccessRules {
  items: Array<MenuAccessRules>;
}

export interface MenuAccessRules {
  menu: string;
  canAccessMenu: boolean;
  actions?: ActionsAccessRules;
  subMenu?: Array<MenuAccessRules>;
}

export interface ActionsAccessRules {
  canSearch: boolean;
  canVisualize: boolean;
  canInclude?: boolean;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export enum UserAccessRulesEnum {
  notifications = 'myNotifications',
  customers = 'myCustomers',
  prospects = 'myProspects',
  contacts = 'myContacts',
  sales = 'mySales',
  salesOrders = 'mySalesOrders',
  salesBudgets = 'mySalesBudgets',
  products = 'myProducts',
  salesGoals = 'mySalesGoals',
  commissions = 'myCommissions'
}
